<template>
  <div class="yhc-df-kazai-detail-input--set-sizes mt-3">
    <div class="card yhc-sub-card">
      <div class="card-header">
        お荷物のサイズ
        <span
          v-if="!isKaguidoOption"
          class="yhc-card-header--notice"
          >※運賃は、サービスご利用時に弊社スタッフによりサイズ査定（採寸）を行い確定いたします。</span
        >
      </div>
      <div
        v-if="!isKaguidoOption"
        class="card-body"
      >
        <div class="d-flex flex-wrap justify-content-center form-group-wrapper">
          <div class="form-group">
            <label
              for="kazaiHeight"
              class="d-block bold"
              >高さ</label
            >
            <div class="input-size-unit-multiple-mark">
              <div class="input-size-unit">
                <input
                  v-model="kazaiData.size_height"
                  :class="kazaiData.size_height ? '' : 'border border-danger'"
                  type="number"
                  class="form-control d-inline-block input-kazai-size"
                  id="kazaiHeight"
                  placeholder="高さ"
                />
                cm
              </div>
              <span class="multiple"><ficon type="x" /></span>
            </div>
          </div>
          <div class="form-group">
            <label
              for="kazaiWidth"
              class="d-block bold"
              >幅</label
            >
            <div class="input-size-unit-multiple-mark">
              <div class="input-size-unit">
                <input
                  v-model="kazaiData.size_width"
                  :class="kazaiData.size_width ? '' : 'border border-danger'"
                  type="number"
                  class="form-control d-inline-block input-kazai-size"
                  id="kazaiWidth"
                  placeholder="幅"
                />
                cm
              </div>
              <span class="multiple"><ficon type="x" /></span>
            </div>
          </div>
          <div class="form-group">
            <label
              for="kazaiDepth"
              class="d-block bold"
              >奥行</label
            >
            <div class="input-size-unit">
              <input
                v-model="kazaiData.size_depth"
                :class="kazaiData.size_depth ? '' : 'border border-danger'"
                type="number"
                class="form-control d-inline-block input-kazai-size"
                id="kazaiDepth"
                placeholder="奥行"
              />
              cm
            </div>
          </div>
        </div>
        <div
          v-if="kazaiData.sizeErrorMessage"
          class="text-danger text-center pt-1"
        >
          {{ kazaiData.sizeErrorMessage }}
        </div>
        <div v-else-if="kazaiData.basePriceBySizeRank">
          <div class="text-center pt-1">
            <span class="bold"
              >基本料金: ¥{{ kazaiData.basePriceBySizeRank.toLocaleString() }}</span
            >
            <span class="small text-muted px-1"
              >(サイズランク: {{ kazaiData.sizeRank.toUpperCase() }})</span
            >
          </div>
        </div>
        <div
          v-if="kazaiData.largeSizeNoticeMessage"
          class="text-center text- pt-1"
        >
          {{ kazaiData.largeSizeNoticeMessage }}
        </div>
      </div>
      <div
        v-if="isKaguidoOption"
        class="card-body bold"
      >
        3辺合計が450cmを超えるお荷物はお取り扱いできません。（ベッドを除く）
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { YhcEFInputOneKazaiTypeDataObject } from '../../YhcEFInputOneKazaiTypeDataObject'

export default {
  emits: ['updateSizes'],
  props: {
    kazaiData: {
      type: Object as PropType<YhcEFInputOneKazaiTypeDataObject>,
      required: false,
    },
    isKaguidoOption: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
